import React, { FC } from 'react';
import { useParams } from 'react-router';
import Edit from 'components/document-templates/components/Edit';

const Screen: FC = () => {
  const { id } = useParams<{ id: string | undefined }>();

  return (
    <Edit
      templatesEntityName="templates"
      templatesEntityEndpoint={`templates?id=${id}`}
      templatesDropdownsEntityName="template-dropdowns"
      templatesDropdownsEntityEndpoint="templates/dropdown-options"
    />
  );
};

export default Screen;
